import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ContentWrapperStyled,
  DescriptionStyled,
  HeadlineStyled,
  SubHeadlineStyled,
  ItemStyled,
} from './MaintenanceScreen.styled';
import LayoutLogin from 'components/LayoutLogin';

interface IMaintenanceScreenProps {
  isBlocked: boolean;
  isMaintenance: boolean;
}

const MaintenanceScreen: FC<IMaintenanceScreenProps> = ({ isMaintenance }) => {
  const { t } = useTranslation();

  // isMaintenance wins when both are true: telling the user to update is
  // misleading during a declared maintenance window, since updating won't help.
  const textKeyPrefix = isMaintenance
    ? 'maintenanceScreen.maintenance'
    : 'maintenanceScreen.versionBlocked';

  return (
    <LayoutLogin>
      <ItemStyled>
        <ContentWrapperStyled>
          <HeadlineStyled type='primary'>
            {t(`${textKeyPrefix}.headline`)}
          </HeadlineStyled>
          <SubHeadlineStyled>
            {t(`${textKeyPrefix}.subHeadline`)}
          </SubHeadlineStyled>
          <DescriptionStyled>
            {t(`${textKeyPrefix}.description`)}
          </DescriptionStyled>
        </ContentWrapperStyled>
      </ItemStyled>
    </LayoutLogin>
  );
};

export default MaintenanceScreen;
